import { PageLayout } from "@/components/PageLayout";
import { useSeo } from "@/lib/useSeo";

// Shared layout for plain-language legal and policy pages (Privacy Policy, Accessibility).
// Content is kept in code so it is versioned and reviewed through pull requests.
export const LegalPage = ({ seo, eyebrow, title, updated, intro, sections }) => {
    useSeo(seo);

    return (
        <PageLayout>
            <article className="mx-auto max-w-3xl px-5 pb-24 pt-36 sm:px-8 sm:pt-44">
                <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-brand-accent">{eyebrow}</p>
                <h1 className="mt-5 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-text sm:text-5xl">
                    {title}
                </h1>
                <p className="mt-5 text-sm text-brand-muted">{`Last updated: ${updated}`}</p>
                <p className="mt-8 text-base leading-relaxed text-brand-muted sm:text-lg">{intro}</p>

                <div className="mt-14 space-y-12">
                    {sections.map((section) => (
                        <section key={section.heading} aria-labelledby={section.id}>
                            <h2
                                id={section.id}
                                className="font-heading text-2xl font-extrabold tracking-tight text-brand-text"
                            >
                                {section.heading}
                            </h2>
                            <div className="mt-4 space-y-4 text-base leading-relaxed text-brand-muted [&_a]:font-semibold [&_a]:text-[color:var(--el-accent-text)] [&_a]:underline [&_strong]:text-brand-text [&_ul]:list-disc [&_ul]:space-y-2 [&_ul]:pl-5">
                                {section.body}
                            </div>
                        </section>
                    ))}
                </div>
            </article>
        </PageLayout>
    );
};
